import { render, staticRenderFns } from "./templatemessage.vue?vue&type=template&id=d2a492b8&scoped=true&"
import script from "./templatemessage.vue?vue&type=script&lang=js&"
export * from "./templatemessage.vue?vue&type=script&lang=js&"
import style0 from "./templatemessage.vue?vue&type=style&index=0&id=d2a492b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a492b8",
  null
  
)

export default component.exports